/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from '@mui/styles';
import { Sidebar, TextField } from 'apollo-react';
import Drawer from 'apollo-react/components/Drawer';
import Typography from 'apollo-react/components/Typography';
import Close from 'apollo-react-icons/Close';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import _ from 'lodash';
import qs from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RRLink, useHistory } from 'react-router-dom';

import SearchDrawer from './customMenus/SearchDrawer';
import { processMenuItems } from './processMenuItems';
import { clearErrors } from '../../actions/ErrorActions';
import { fetchFavorites } from '../../actions/FavoritesActions';
import { fetchRecentEvents } from '../../actions/RecentEventsActions';
import { saveSidenavSearchText, sidenavIsSubMenu } from '../../actions/SidenavActions';
import { clearWarnings } from '../../actions/WarningActions';
import { INPUT_ICON_DEFAULT_SIZE } from '../../constants/CommonStylesConstants';
import { ARCHIVED_MODE_MENU_ITEMS } from '../../constants/NavigationConstants';
import { PILGRIM_TOP_MENU_HEIGHT, SIDEBAR_WIDTH } from '../../constants/SizeConstants';
import {
  POWERBI_REPORTS_PAGE,
  REPOSITORY_LIST,
  SMART_INSIGHT_REPORTS_LIST,
  WORKFLOW_STEP,
} from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { FORMS_DESIGN_RIGHT } from '../../form-designer/constants/editor.constants';
import {
  isExternalLink,
  prependProtocol,
  preprocessUrl,
} from '../../form-designer/utils/controls/ssHyperLink.utils';
import { getIsRtlLanguage } from '../../selectors/AuthSelectors';
import { getAvailableNavigation } from '../../selectors/MasterSetupPageSelectors';
import { getEnvVar } from '../../utils/env';
import LazyText from '../LazyText';
import NavigateLink from '../NavigateLink';

const useStyles = makeStyles({
  sidebar: {
    '& > div > div > div > button': {
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '& > div > div > div > button > p': {
      display: 'block',
      fontSize: '9px',
      marginBottom: '0px',
      textAlign: 'center',
      wordBreak: 'break-word',
      width: '100%',
      lineHeight: '100%',
    },
    // This hides the button that opens the sidebar
    '& > div > div > div:nth-of-type(3)': {
      display: 'none',
    },
    '& > div > div > div:nth-of-type(1)': {
      display: 'none',
    },
    // This ensures the div containing the buttons takes up the full height
    '& > div > div > div:nth-of-type(2)': {
      paddingTop: PILGRIM_TOP_MENU_HEIGHT,
      height: '100%',
    },
    // This pushes the third button from the end to the bottom
    '& > div > div > div:nth-of-type(2) > button:nth-last-of-type(3)': {
      marginTop: 'auto',
    },
    '& > div > div > div:nth-of-type(2) > button': {
      padding: 0,
    },
    '& > div > div': {
      zIndex: 1300,
    },
  },
  sidebarRTL: {
    '& > div > div': {
      zIndex: 1300,
      right: 0,
      left: 'auto',
    },
  },
  drawerPaper: {
    float: 'left',
    position: 'fixed',
    top: PILGRIM_TOP_MENU_HEIGHT,
    left: SIDEBAR_WIDTH,
    width: '22rem',
    height: `calc(100vh - ${PILGRIM_TOP_MENU_HEIGHT}px)`,
    transition: 'all 600ms ease-in-out',
    zIndex: 100,
    backgroundColor: '#fff',
    paddingTop: '1rem',
    paddingRight: '1rem',
    paddingLeft: '2rem',
    '& [class*="MuiPaper-elevation1"]': {
      border: 'none !important',
    },
  },
  drawerPaperRtl: {
    float: 'right',
    position: 'fixed',
    top: PILGRIM_TOP_MENU_HEIGHT,
    right: SIDEBAR_WIDTH,
    width: '22rem',
    height: `calc(100vh - ${PILGRIM_TOP_MENU_HEIGHT}px)`,
    transition: 'all 600ms ease-in-out',
    zIndex: 100,
    backgroundColor: '#fff',
    paddingTop: '1rem',
    paddingRight: '1rem',
    paddingLeft: '2rem',
  },
  drawerSubtitle: {
    fontSize: '12px',
  },
  drawerSubgroups: {
    padding: '1rem 0rem',
  },
  drawerSubgroupTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  drawerGroup: {
    listStyle: 'none',
  },
  drawerLinkContainer: {
    lineHeight: 1.5,
    padding: '0.5rem 0',
  },
  drawerLink: {
    color: '#297dfd',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  searchIcon: INPUT_ICON_DEFAULT_SIZE,
  clearIcon: INPUT_ICON_DEFAULT_SIZE,
});

//                        Admin              System Setup       Monitoring
const bottomMenuOrder = ['ModuleAdminMenu', 'SystemSetupMenu', 'AdminMenu'].reverse();

const Sidenav = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const navigation = useSelector(getAvailableNavigation);

  const sidenavSearchText = useSelector((state) => state.sidenav.searchText);
  const isOpenSubmenu = useSelector((state) => state.sidenav.isSubMenu);
  const userRights = useSelector((state) => state.userRights);
  const isRtlLanguage = useSelector(getIsRtlLanguage);
  const { isExternalUser, isArchiveMode } = auth;

  const [drawer, setDrawer] = useState(null);
  const [searchText, setSearchText] = useState('');

  const classes = useStyles();
  const translateString = useTranslation();

  // scroll for bottom section on menu
  const searchInputBox = useRef();

  useEffect(() => {
    if (!isExternalUser) {
      dispatch(fetchFavorites());
      dispatch(fetchRecentEvents());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSearchText(sidenavSearchText);
  }, [sidenavSearchText]);

  const closeDrawer = () => {
    dispatch(saveSidenavSearchText(searchText));
    dispatch(sidenavIsSubMenu(false));
  };

  const clearSearchText = () => {
    setSearchText('');
    searchInputBox.current.focus();
  };

  const toggleDrawer = (newDrawer) => () => {
    const isDrawerClosed =
      newDrawer === undefined || (isOpenSubmenu && _.isEqual(newDrawer, drawer));

    if (isDrawerClosed) {
      dispatch(sidenavIsSubMenu(false));
      setDrawer(null);
    } else {
      dispatch(sidenavIsSubMenu(true));
      setDrawer(newDrawer);
    }

    setSearchText('');
    setTimeout(() => {
      if (!isDrawerClosed && searchInputBox.current) {
        searchInputBox.current.focus();
      }
    }, 100);
  };

  const createEntity = (
    entityViewName,
    entityType,
    formKey,
    containerWorkflowKey,
    workflowKey,
    stepId
  ) => {
    toggleDrawer();
    history.push(
      `${WORKFLOW_STEP}?${qs.stringify({
        containerWorkflowKey,
        workflowKey,
        stepId,
        entityViewName,
        entityType,
      })}`
    );
  };

  const renderGroupLink = (link) => {
    if (link.ID === 'NewWorkflowDesigner') {
      return (
        <NavigateLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={getEnvVar('WORKFLOW_DESIGNER_APP_URL')}
          target="_blank"
        >
          {link.Text}
        </NavigateLink>
      );
    }

    if (link.ID === 'R2TDesigner') {
      const userFullName = localStorage.getItem('userFullName');
      const preprocessedUrl = `${getEnvVar('R2T_DESIGNER_APP_URL')}?token=${
        auth.token
      }&userFullName=${userFullName}`;
      return (
        <NavigateLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={preprocessedUrl}
          target="_blank"
        >
          {link.Text}
        </NavigateLink>
      );
    }

    if (link.Type === 'BulkEdit') {
      const { FormName } = link.NavigateURL ? qs.parse(link.NavigateURL.split('?')[1]) : {};

      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: '/bulk-edit',
            search: qs.stringify({
              entityType: link.EntityName,
              formKey: FormName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.ID === 'SmartInsightReports') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={SMART_INSIGHT_REPORTS_LIST}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.NavigateURL?.includes('.aspx')) {
      const preprocessedUrl = preprocessUrl(link.NavigateURL, auth.token);

      return (
        <NavigateLink
          className={classes.drawerLink}
          to={preprocessedUrl.join('?')}
          target="_blank"
          onClick={() => dispatch(sidenavIsSubMenu(false))}
        >
          {link.Text}
        </NavigateLink>
      );
    }

    if (link.Type === 'EntitySearch') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: '/find',
            search: qs.stringify({ entityName: link.EntityName, searchName: link.SavedSearchName }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.Type === 'PowerBIReports') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: POWERBI_REPORTS_PAGE,
            search: qs.stringify({
              entityName: link.EntityName,
              moduleName: link.ModuleName,
              searchName: link.SavedSearchName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    const masterSetupTypes = [
      'MasterSetupSearch',
      'MasterSetupSearchDisableAdd',
      'MasterSetupDisableBulkImport',
      'MasterSetupOptimizedSearch',
      'MasterSetupOptimizedSearchDisableAdd',
      'MasterSetupOptimizedSearchDisableBulkImport',
    ];

    if (masterSetupTypes.includes(link.Type)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: '/master-setup',
            search: qs.stringify({
              entityName: link.EntityName,
              searchName: link.SavedSearchName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    const monitoringQueueSetupTypes = ['MonitoringQueue'];

    if (monitoringQueueSetupTypes.includes(link.Type)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: '/monitoring-queue',
            search: qs.stringify({
              entityName: link.EntityName,
              searchName: link.SavedSearchName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    const repositoryConfigurationTypes = [
      'RepositoryConfigurationList',
      'RepositoryConfigurationListDisableAdd',
    ];

    if (repositoryConfigurationTypes.includes(link.Type)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: REPOSITORY_LIST,
            search: qs.stringify({
              entityName: link.EntityName,
              searchName: link.SavedSearchName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.Type === 'ModuleUpgrade') {
      const pathname = '/upgrade-modules';
      return (
        <RRLink className={classes.drawerLink} onClick={closeDrawer} to={pathname}>
          {link.Text}
        </RRLink>
      );
    }

    const dashboardLinks = [
      'FormsEditor',
      'EntityEditor',
      'NewSmartInsight',
      'NewSavedSearches',
      'AppMigration',
    ];

    if (dashboardLinks.includes(link.ID)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={link.NavigateURL}
          target="_blank"
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.Type === 'CacheList') {
      return (
        <RRLink className={classes.drawerLink} onClick={closeDrawer} to={link.NavigateURL}>
          {link.Text}
        </RRLink>
      );
    }

    if (link.Type === 'DataSources') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={link.NavigateURL}
          target="_blank"
        >
          {link.Text}
        </RRLink>
      );
    }

    const workflowMasterSetupTypes = [
      'WorkflowBasedMasterSetupSearch',
      'WorkflowBasedMasterSetupSearchDisableAdd',
      'WorkflowBasedMasterSetupSearchDisableBulkImport',
    ];

    if (workflowMasterSetupTypes.includes(link.Type)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={{
            pathname: '/workflow-master-setup',
            search: qs.stringify({
              containerWorkflowKey: link.ContainerWorkflowKey,
              entityName: link.EntityName,
              entityViewName: link.ViewName,
              searchName: link.SavedSearchName,
              stepId: link.StepId,
              workflowKey: link.WorkflowKey,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (isExternalLink(link.NavigateURL)) {
      return (
        <NavigateLink
          className={classes.drawerLink}
          onClick={closeDrawer}
          to={prependProtocol(link.NavigateURL)}
          target="_blank"
        >
          {link.Text}
        </NavigateLink>
      );
    }

    return (
      <a
        className={classes.drawerLink}
        onClick={() => {
          closeDrawer();
          dispatch(clearWarnings());
          dispatch(clearErrors());
          createEntity(
            link.ViewName,
            link.EntityName,
            link.FormKey,
            link.ContainerWorkflowKey,
            link.WorkflowKey,
            link.StepId
          );
        }}
      >
        {link.Text}
      </a>
    );
  };

  const showDrawer = drawer?.Id === 'SystemSetupMenu' || drawer?.Id === 'ModuleAdminMenu';

  const renderDrawer = () => {
    if (!isOpenSubmenu) {
      return null;
    }

    const searchDrawerProps = { drawer, searchText, renderGroupLink, closeDrawer };
    return (
      <Drawer
        open={isOpenSubmenu}
        onClose={toggleDrawer()}
        classes={{ paper: isRtlLanguage ? classes.drawerPaperRtl : classes.drawerPaper }}
      >
        <LazyText text={translateString(drawer.Title)}>
          <Typography variant="title1">{translateString(drawer.Title)}</Typography>
        </LazyText>
        <LazyText text={translateString(drawer.SubTitle)}>
          <Typography ui-ta="action-drawer" className={classes.drawerSubtitle} variant="body2">
            {translateString(drawer.SubTitle)}
          </Typography>
        </LazyText>

        {showDrawer && (
          <TextField
            startIcon={<Search className={classes.searchIcon} />}
            icon={searchText !== '' ? <Close className={classes.clearIcon} /> : null}
            iconProps={{ onClick: clearSearchText, 'ui-ta': 'ClearSearchButton' }}
            placeholder={translateString('Search')}
            inputRef={searchInputBox}
            value={searchText}
            fullWidth
            onChange={(e) =>
              setSearchText(e.target.value.length === 1 ? e.target.value.trim() : e.target.value)
            }
          />
        )}

        {drawer.Component && <drawer.Component classes={classes} closeDrawer={closeDrawer} />}

        {searchText !== '' && showDrawer ? (
          <SearchDrawer {...searchDrawerProps} />
        ) : (
          drawer.templateData &&
          drawer.templateData.map((group, index) => (
            <div key={index} className={classes.drawerSubgroups}>
              <p className={classes.drawerSubgroupTitle}>{group.Text}</p>
              <ul className={classes.drawerGroup}>
                {group.Links.filter(
                  (link) =>
                    link.ID !== 'FormsEditor' ||
                    (link.ID === 'FormsEditor' && userRights.includes(FORMS_DESIGN_RIGHT))
                ).map((link) => (
                  <li key={link.ID} ui-ta={link.ID} className={classes.drawerLinkContainer}>
                    {renderGroupLink(link)}
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </Drawer>
    );
  };

  const drawerPanel = renderDrawer();

  const menuItems = processMenuItems(
    navigation,
    isArchiveMode,
    ARCHIVED_MODE_MENU_ITEMS,
    bottomMenuOrder
  );

  const onClickHandler = (contentData, NavigateURL) => {
    if (NavigateURL !== null && NavigateURL !== '') {
      dispatch(sidenavIsSubMenu(false));
      return history.push(NavigateURL);
    }
    if (contentData) {
      return toggleDrawer({ ...contentData })();
    }
  };

  return (
    <>
      {drawerPanel}
      <div className={classNames(classes.sidebar, isRtlLanguage && classes.sidebarRTL)}>
        <Sidebar
          collapsed
          variant="brand"
          menuItems={menuItems}
          onClick={({ contentData, navigateURL }) => onClickHandler(contentData, navigateURL)}
          logoComponentProps={{
            orgName: 'IQVIA',
            appName: 'Smart Solve',
            onClick: () => {},
          }}
        />
      </div>
    </>
  );
};

export default Sidenav;
